import { useEffect, useState } from 'react';

import { searchPageLoadUFOExperience } from '../../../common/ui/ufo/experiences';
import { usePrimaryProduct } from '../../../controllers/store/bootstrap/accessors';

export const LoadUFOExperienceSuccess = () => {
	const [successCalled, setSuccessCalled] = useState(false);
	const [primaryProduct] = usePrimaryProduct();

	useEffect(() => {
		if (successCalled) {
			return;
		}

		if (primaryProduct && searchPageLoadUFOExperience.state.id === 'STARTED') {
			searchPageLoadUFOExperience.success();
			setSuccessCalled(true);
		}
	}, [primaryProduct, successCalled]);

	return null;
};
